export default {
  blank: () => import("/Users/michael/Development/pingzapper/site/pz-site/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/Users/michael/Development/pingzapper/site/pz-site/layouts/default.vue").then(m => m.default || m)
}